import React from 'react';
import { Link } from 'react-router-dom';

function PageNotFound() {
    return (
        <>
            <div className='element page404'>
                <div className='col-50' id='div-404-a'>
                    <img src='/images/404trooper.png' alt='Not Found' loading='lazy' className='img-404' />
                </div>
                <div className='col-50' id='div-404-b'>
                    <p className='title-a'>404</p>
                    <p className='title-b'>ERROR</p>
                    <p className='text-a'>This isn’t the</p>
                    <p className='text-a'>page you’re</p>
                    <p className='text-a mb-20'>looking for.</p>
                    <p className='text-b'>You can go about</p>
                    <p className='text-b'>your business</p>
                    <p className='text-b mb-20'>on the <Link to='/'>homepage</Link>.</p>
                    <p className='text-c'>Move along...</p>
                    <p className='text-c'>Move along...</p>
                </div>
            </div>
        </>
    );
}

export default PageNotFound;
